<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperRequestsBooks',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'requestsBooksModule',
    };
  },
};
</script>
